import type { LabelType, NodeType } from '../../../components/forest';
import type { CustomerRole } from '../../customers/types/role';
import type { SectionResponse } from './api';
import type { CustomerMinimal } from './company';

export const sectionTreeNodeIDs = ['section', 'customer'] as const;
export type SectionTreeNodeTypeID = (typeof sectionTreeNodeIDs)[number];
export type SectionTreeNodeSection = Omit<SectionResponse, 'children'> & { company_id: string };
export type SectionTreeNode = SectionTreeNodeSection | CustomerMinimal;
export type SectionTreeEdgeTypeID = 'section' | 'customer' | 'connection';
export type SectionTreeEdge = CustomerRole;
export type SectionTreeNodeType = NodeType<
  SectionTreeNode,
  SectionTreeNodeTypeID,
  SectionTreeEdgeTypeID,
  SectionTreeEdge
>;
export type SectionTreeEdgeType = LabelType<
  SectionTreeNode,
  SectionTreeEdge,
  SectionTreeNodeTypeID
>;
